import {apolloClient, gql} from '../graphql';
import {logAndThrowGraphQLErrors} from '../graphql/helpers';
import type {ID, Note} from 'shared/src/models';

export const createNote = async (note: Omit<Note, 'id'>, projectId: ID): Promise<Note> => {
	const {data, errors} = await apolloClient.mutate({
		mutation: gql(/* GraphQL */ `
			mutation CreateNote($note: NewNoteInput!, $projectId: ID!) {
				createNote(note: $note, projectId: $projectId) {
					id
				}
			}
		`),
		variables: {
			note,
			projectId,
		},
	});

	if (errors && errors.length > 0) {
		logAndThrowGraphQLErrors(errors);
	}

	return {
		...note,
		id: data!.createNote.id,
	};
};

export const getNotes = async ({ids}: {ids: ID[]}): Promise<Note[]> => {
	const {data, error} = await apolloClient.query({
		query: gql(/* GraphQL */ `
			query GetNotes($ids: [ID!]!) {
				notes(ids: $ids) {
					id
					name
					content
				}
			}
		`),
		variables: {
			ids,
		},
		fetchPolicy: 'no-cache',
	});

	if (error) {
		throw error;
	}

	return data.notes;
};

export const updateNote = async (note: Note): Promise<Note> => {
	const {data, errors} = await apolloClient.mutate({
		mutation: gql(/* GraphQL */ `
			mutation UpdateNote($note: UpdatedNoteInput!) {
				updateNote(note: $note) {
					id
				}
			}
		`),
		variables: {
			note,
		},
	});

	if (errors && errors.length > 0) {
		logAndThrowGraphQLErrors(errors);
	}

	return note;
};

export const deleteNote = async (id: ID): Promise<void> => {
	const {errors} = await apolloClient.mutate({
		mutation: gql(/* GraphQL */ `
			mutation DeleteProjectNote($id: ID!) {
				deleteNote(id: $id)
			}
		`),
		variables: {
			id,
		},
	});

	if (errors && errors.length > 0) {
		logAndThrowGraphQLErrors(errors);
	}
};
